function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".linux-cls-1{fill:#edeff0;}.linux-cls-2{fill:#273339;}.linux-cls-3{fill:#212121;}.linux-linux-cls-4{fill:#fdc113;}.linux-cls-5{fill:#63491c;}.linux-cls-6{fill:#465b65;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "linux-cls-1",
  points: "106.06 78.69 106.68 92.98 96.74 111.63 81.2 142.07 78.1 167.55 89.28 203.59 114.76 217.89 153.29 217.89 189.33 190.54 205.49 147.67 168.2 102.3 157.64 76.83 106.06 78.69"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "linux-cls-2",
  d: "M194.3,114.11c-9.94-14.29-18-23-22.37-41s1.24-13-2.48-28.59a49,49,0,0,0-8.08-18c-3.73-4.35-8.08-6.83-10.57-7.46-5.59-3.1-18.64-8.07-34.8.63C99.23,28.36,101.09,47,104.2,84.9A19,19,0,0,1,102.33,93c-2.48,5.6-6.83,10.57-10.56,14.92-4.35,6.21-8.7,12.43-11.81,19.26-7.46,14.29-14.29,32.31-12.43,39.15,3.11-.62,42.26,59,42.26,60.28,2.48-.62,13-.62,22.37-.62,13.05-.63,20.51-1.25,31.07,1.24,0-1.87-.62-3.73-.62-5.59,0-3.73.62-6.84,1.24-11.19.62-3.11,1.25-6.21,1.87-9.94-6.22,5.59-17.4,11.8-28,13.67-9.32,1.86-24.85-1.24-32.31-10.57a3.77,3.77,0,0,0,2.49-.62c1.86-.62,3.72-1.24,4.34-2.48,1.87-3.11.63-6.22-.62-8.08s-10.56-8.7-14.91-12.43-6.84-5.59-9.32-8.08l-5-5c-1.25-1.24-1.87-2.48-2.49-3.11A23.08,23.08,0,0,1,78.72,152c.62-6.84,3.11-12.43,6.21-18.65,1.25-2.48,4.35-7.45,4.35-7.45s-10.56,26.1-5,34.18a84.12,84.12,0,0,1,3.11-16.16c1.86-5.59,5-13.67,8.7-18s13-20.51,13.67-30.45c0-4.35.62-8.7.62-11.81-2.48-2.48,41-8.7,43.5-1.86.62,2.48,9.32,24.85,14.29,36.66,2.49,5.59,5.6,10.56,7.46,16.78a102.22,102.22,0,0,1,3.11,25.48,41.39,41.39,0,0,1-.62,8.08c1.24,0,25.47-26.1-3.11-47.85,0,0,17.4,8.07,18,24.23a47.73,47.73,0,0,1-6.22,25.48c.63,0,13,5.59,13.68,5.59,2.48,0,7.45-1.86,7.45-1.86.62-1.87,2.49-6.84,2.49-8.7C214.81,151.4,204.24,128.4,194.3,114.11Z"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "linux-cls-1",
  cx: 115.38,
  cy: 60.67,
  rx: 8.08,
  ry: 12.43
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "linux-cls-1",
  cx: 143.35,
  cy: 60.05,
  rx: 10.56,
  ry: 14.29
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "linux-cls-3",
  cx: 115.58,
  cy: 62.07,
  rx: 4.35,
  ry: 7.46,
  transform: "translate(-6.87 14.98) rotate(-7.2)"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "linux-linux-cls-3",
  cx: 142.72,
  cy: 62.53,
  rx: 6.21,
  ry: 8.08
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "linux-linux-cls-4",
  d: "M225.37,199.24a23.78,23.78,0,0,1-10.56-8.7c-1.87-3.1-1.24-11.8-4.35-15.53-1.87-2.49-4.35-1.24-5-1.24-5.6,1.24-18.65,9.94-27.34,0-1.25-1.25-3.11-3.11-6.22-3.11s-4.35,1.24-5.59,3.73-1.24,4.35-1.24,10.56a113.41,113.41,0,0,1-.63,14.92c-1.24,10.56-3.1,16.77-3.1,23,0,6.83,1.86,11.18,4.35,13,1.86,1.86,5,3.11,11.8,3.11s11.19-2.49,15.54-6.84c3.11-3.11,5.59-4.35,14.29-10.56,6.84-4.35,17.4-10,19.27-11.81,1.24-1.24,3.1-1.87,3.1-5.59C229.72,201.11,227.24,199.87,225.37,199.24Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "linux-linux-cls-4",
  d: "M100.47,201.11c-6.22-9.94-6.84-11.81-11.19-18-3.73-6.22-11.8-18-16.78-18-3.72,0-5.59,1.86-8.07,4.35s-5,8.08-9.33,11.18c-3.72,3.11-14.29,2.49-16.77,6.22s2.48,9.32,2.48,18.64c0,3.73-3.1,6.21-3.73,8.7-.62,3.11-1.24,5,0,7.46,2.49,3.72,5.6,5,26.72,9.32,11.19,2.48,21.75,8.7,28.59,9.32s18.64,0,18.64-16.78C111.65,213.54,106.06,211.05,100.47,201.11Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "linux-linux-cls-4",
  d: "M112.27,88.63c-3.72-2.48-6.83-5-6.83-8.7s2.49-5,6.21-8.08c.62-.62,7.46-6.83,14.3-6.83s14.91,4.35,18,5.59c5.59,1.24,11.18,2.49,10.56,6.84-.62,6.21-1.24,7.45-7.46,10.56-4.35,1.24-12.42,8.08-18,8.08a41.17,41.17,0,0,1-8.7-.62C118.49,94.85,115.38,91.74,112.27,88.63Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "linux-cls-5",
  d: "M111,83.66a13.56,13.56,0,0,0,5,3.11A29.89,29.89,0,0,0,119.11,88h5.59c3.11,0,7.46-1.24,11.81-3.73,4.35-1.86,5-3.1,8.08-4.35,3.11-1.86,6.21-3.73,5-4.35s-2.49,0-6.84,2.49c-3.72,2.48-6.83,3.73-10.56,5.59-1.86.62-4.35,1.87-6.21,1.87h-5.6c-1.86,0-3.1-.63-5-1.25-1.24-.62-1.86-1.24-2.48-1.24-1.25-.62-3.73-3.11-5-3.73,0,0-1.25,0-.63.62Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "linux-cls-5",
  d: "M129.67,70c.63,1.24,1.87,1.24,2.49,1.86a1.91,1.91,0,0,0,1.24.63,1.2,1.2,0,0,0-.62-1.87C132.78,69.37,129.67,69.37,129.67,70Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "linux-cls-5",
  d: "M119.73,71.23c0,.62,1.24,1.25,1.24.62.63-.62,1.25-1.24,1.87-1.24,1.24-.62.62-1.24-1.24-1.24C120.35,70,120.35,70.61,119.73,71.23Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "linux-cls-6",
  d: "M180,181.22v1.87c1.24,2.48,4.35,3.11,6.83,3.11,3.73,0,7.46-2.49,9.33-5,0-.62.62-1.24,1.24-1.86a37.23,37.23,0,0,1,2.48-3.73,2.16,2.16,0,0,1-.62-1.24c-.62-1.24-2.48-2.49-5-3.11a27.36,27.36,0,0,0-6.21-1.24c-5.6-.62-8.7,1.24-10.57,3.11a.61.61,0,0,1,.63.62,5.63,5.63,0,0,1,1.86,4.35C180.63,179.36,180,180,180,181.22Z"
});

var SvgLinux = function SvgLinux(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Linux Icon",
    viewBox: "0 0 262 255",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinux, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Linux.a75c25f4.svg";
export { ForwardRef as ReactComponent };